import EditablePropsType from '../../../types/composer';
import { faHandHoldingSeedling } from '@fortawesome/pro-light-svg-icons/faHandHoldingSeedling';
import { faHeadSideBrain } from '@fortawesome/pro-light-svg-icons/faHeadSideBrain';
import { faClock } from '@fortawesome/pro-light-svg-icons/faClock';

import { IconProp } from '@fortawesome/fontawesome-svg-core';

export const featureIconMap: { [key: string]: IconProp } = {
  'hand-holding-seedling': faHandHoldingSeedling,
  'head-side-brain': faHeadSideBrain,
  clock: faClock,
};

export const columnsSchema = {
  type: EditablePropsType.Array,
  label: 'Columns',
  name: 'columns',
  items: {
    type: EditablePropsType.Array,
    label: 'Section',
    name: 'section',
    items: {
      type: EditablePropsType.Object,
      properties: {
        title: {
          type: EditablePropsType.Text,
          name: 'title',
          label: 'Title',
        },
        icon: {
          type: EditablePropsType.Object,
          label: 'Icon',
          name: 'icon',
          properties: {
            name: {
              type: EditablePropsType.Select,
              label: 'Name',
              name: 'name',
              selectOptions: {
                options: Object.keys(featureIconMap).map((item) => ({
                  value: item,
                  label: item,
                })),
              },
            },
          },
        },
        features: {
          name: 'features',
          label: 'Features',
          type: EditablePropsType.RichText,
        },
      },
    },
  },
};

export default columnsSchema;
